// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1GF23","header":"PatientQuestionnaire_header__3AQdn","info":"PatientQuestionnaire_info__k3wGG"};